import React from 'react';

export interface FacebookProps {
  className?: string;
}

const WeatherStormy: React.FC<FacebookProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 30 30"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 5C14.6069 5 12.5391 6.40095 11.5756 8.43186C11.4042 8.79312 11.0341 9.01755 10.6345 9.00253C10.5899 9.00085 10.5451 9 10.5 9C8.95622 9 7.64343 10.0001 7.17919 11.3906C7.06503 11.7325 6.7757 11.9865 6.42189 12.0555C5.04161 12.3244 4 13.5416 4 15C4 16.6569 5.34315 18 7 18H10.2251L11.1026 15.3675C11.3749 14.5509 12.1391 14 13 14H17C17.6429 14 18.2466 14.309 18.6225 14.8306C18.9984 15.3521 19.1007 16.0226 18.8974 16.6325L18.4415 18H19.5H22C24.2091 18 26 16.2091 26 14C26 12.3002 24.9394 10.8457 23.4403 10.2669C23.135 10.149 22.9067 9.88913 22.8291 9.57117C22.1884 6.94682 19.8203 5 17 5ZM22.3378 19.9907C25.4943 19.8155 28 17.2004 28 14C28 11.6307 26.6271 9.58428 24.6363 8.60897C23.6195 5.35905 20.5864 3 17 3C14.0303 3 11.4403 4.61815 10.0605 7.0173C8.01957 7.17862 6.29376 8.45371 5.48774 10.2331C3.46555 10.8742 2 12.765 2 15C2 17.7614 4.23858 20 7 20H9.55848L9.10263 21.3675C8.89933 21.9774 9.00161 22.6479 9.37752 23.1694C9.75342 23.691 10.3571 24 11 24H12.0585L11.6026 25.3675C11.3093 26.2475 11.6595 27.2137 12.4485 27.7013C13.2376 28.1889 14.2583 28.0701 14.9142 27.4142L20.9142 21.4142L22.3378 19.9907ZM19.5 20H18H17.7749H16.6716H15.6667L16.3333 18L17 16H14.8918H13L11.6667 20L11 22H12.7251H13.1082H14.6716H14.8333L14.1667 24L13.5 26L16.6623 22.8377L17.5 22L19.5 20Z"
        fill="white"
      />
    </svg>
  );
};

export default WeatherStormy;
